import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../models/global.model';
import { SessionStorageService } from '../services/session-storage.service';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// import { environment } from '../../environments/environment';
import { EnvironmentService } from '../services/environment.service';

@Injectable({ providedIn: 'root' })
export class GlobalsService {
  private http = inject(HttpClient);
  private ss = inject(SessionStorageService);
  private envSvc = inject(EnvironmentService);

  private environment;
  public baseUrl: string;
  private firm: string;
  private app: string;
  private org: string;

  constructor() {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    this.org = this.environment.org;
    this.firm = this.environment.firm || '';
    this.app = this.ss.get('currentApp') || this.environment.defaultApp || 'pp';
    this.org = this.environment.org || 'basev2';
  }
}
